var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-800.865,-334.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,740.559,-589.373)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,603.373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.306,341.985C160.306,336.381 158.08,331.006 154.117,327.044C150.155,323.081 144.78,320.855 139.176,320.855L81.437,320.855C75.833,320.855 70.458,323.081 66.495,327.044C62.533,331.006 60.306,336.381 60.306,341.985L60.306,399.725C60.306,405.329 62.533,410.703 66.495,414.666C70.458,418.629 75.833,420.855 81.437,420.855L139.176,420.855C144.78,420.855 150.155,418.629 154.117,414.666C158.08,410.703 160.306,405.329 160.306,399.725L160.306,341.985Z",
    style: {
      fill: "#14606B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-740.559,589.373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880.657,384.855L820.856,384.855L826.013,409.584L875.771,409.584L880.657,384.855Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-740.559,589.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 823.706,
    y: 372.402,
    width: 54.552,
    height: 7.328,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-740.559,589.373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.34,369.958L843.34,366.273C843.34,365.94 843.472,365.622 843.707,365.387C843.942,365.152 844.261,365.02 844.593,365.02C847.425,365.02 854.292,365.02 857.124,365.02C857.457,365.02 857.775,365.152 858.01,365.387C858.245,365.622 858.378,365.94 858.378,366.273L858.378,369.958L863.39,369.958L863.39,364.821C863.39,363.564 862.891,362.359 862.002,361.47C861.113,360.581 859.907,360.082 858.65,360.082C854.185,360.082 847.532,360.082 843.067,360.082C841.81,360.082 840.605,360.581 839.716,361.47C838.827,362.359 838.328,363.564 838.328,364.821C838.328,367.355 838.328,369.958 838.328,369.958L843.34,369.958Z",
    style: {
      fill: "white"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.63847145.svg";
export { ForwardRef as ReactComponent };